document.addEventListener('DOMContentLoaded', () => {

  const sliders = document.querySelectorAll('.editorialSwiper');

  sliders.forEach((slider) => {

    new Swiper(slider, {

      slidesPerView: 1.5,

      spaceBetween: 20,

      speed: 700,

      grabCursor: true,

      watchOverflow: true,

      navigation: {
        nextEl: slider.parentElement.querySelector('.editorial-next'),
        prevEl: slider.parentElement.querySelector('.editorial-prev')
      },

      breakpoints: {

        768: {
          slidesPerView: 1.5,
          spaceBetween: 24
        },

        1200: {
          slidesPerView: 3.5,
          spaceBetween: 28
        }

      }

    });

  });
  

});